import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const getOrders = async (params) => {
	const { data } = await axios.get(`${API}/client/orders`, {
		params,
	});
	return data;
};

export const getCreate = async (params) => {
	const { data } = await axios.get(`${API}/client/orders/data_orders`, {
		params,
	});
	return data;
};

export const saveOrder = async ({ params, base }) => {
	const { data } = await axios.post(`${API}/client/orders/save`, {
		...base,
		params,
	});
	return data;
};

export const approveOrder = async ({ base, element }) => {
	const { data } = await axios.post(`${API}/client/orders/approve`, {
		...base,
		element,
	});
	return data;
};

export const rejectOrder = async ({ base, element }) => {
	const { data } = await axios.post(`${API}/client/orders/reject`, {
		...base,
		element,
	});
	return data;
};

export const deleteOrder = async ({ base, element }) => {
	const { data } = await axios.post(`${API}/client/orders/delete`, {
		...base,
		element,
	});
	return data;
};

export const downloadPdf = async (params) => {
	const { data } = await axios.get(`${API}/client/orders/pdf`, {
		params: params,
		responseType: "blob",
	});
	return data;
};
